import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconDialogue = createIcon({
  displayName: 'IconDialogue',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M2 2H18V4H4V15H2V2ZM22 6V8H8V17H11.41L14 19.59L16.59 17H20V10H22V19H17.41L14 22.41L10.59 19H6V6H22Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
